// Copyright (c) 2021-2025 Broadcom. All Rights Reserved.
// Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
// and/or its subsidiaries.
import { LocaleService, PatternCategories, VIPConfig, VIPService } from "@vmw/ngx-vip";
import { environment } from "src/environments/environment";
import { CspApiService, CspInitializationConfiguration, CspInitializationResult } from "@vmw/csp-ngx-components";
import { AppConfigService } from "@app/services/app-config/app-config.service";
import { of, take } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { ENGLISH } from "@app/resources/i18n/l10n";

export const I18nConfig: VIPConfig = {
    // TODO: rename to VLRServicePlane
    productID: "DPXServicePlane",
    component: "default",
    version: "1.0.0",
    i18nScope: [
        PatternCategories.DATE,
        PatternCategories.NUMBER,
        PatternCategories.CURRENCIES,
        PatternCategories.PLURAL,
        PatternCategories.DATEFIELDS
    ],
    host: environment.vipHost,
    isPseudo: false,
    sourceBundles: [ENGLISH],
    timeout: 5000
};

export function initLocale(vipService: VIPService,
                           localeService: LocaleService,
                           cspApiService: CspApiService,
                           appConfigService: AppConfigService): () => Promise<any> {
    return () => new Promise((resolve, reject) => {
        // For now ignore the browser language (instead locale is loaded from user's profile).
        // localeService.init(getBrowserCultureLang());

        // Initialize CSP service and retrieve user data which is used to initialize locale and VIP.
        const cspInitConfig: CspInitializationConfiguration = {
            localizationEnabled: false,
            orgBrandingDisabled: true,
            serviceDefinitionId: appConfigService.getServiceId()
        };
        cspApiService.setCspEnvironment(appConfigService.cspEnvironment);
        cspApiService.setCspHost(appConfigService.cspOAuthConfig.cspHostname);
        if (appConfigService.redirectPaths) {
            cspApiService.setRedirects(appConfigService.redirectPaths);
        }
        cspApiService.initialize(cspInitConfig)
            .pipe(take(1),
                  mergeMap((initResult: CspInitializationResult) => {
                      localeService.init(initResult.locale);
                      console.log("Loaded locale " + initResult.locale);
                      return of(initResult.locale);
                  }),
                  mergeMap(() => vipService.initData(I18nConfig)))
            .subscribe(
                {
                    next: () => {
                        resolve(true);
                    },
                    error: (error) => {
                        console.warn("Failed to load locale", error);
                        reject(false);
                        return false;
                    }
                });
    });
}
